import { useNavigate } from 'react-router-dom';
import { vehicleDetailsQuestionData } from '@abvehicles/constants/questionData';
import { RoutesList } from '@abvehicles/routes/Routes';
import { useAbVehiclesStore } from '@abvehicles/store/store';
import { useState } from 'react';
import { ErrorMessages } from '@types';
import { parseZodErrors } from '@utils';
import { ZodError } from 'zod';
import { abandonedVehicleDetailsSchema } from '@abvehicles/utils/validations';
import { MultipleTextInputTemplate } from '@templates';

export const VehicleDetailsPage = () => {
  const navigate = useNavigate();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const questionData = vehicleDetailsQuestionData;
  const { vehicleDetails, updateVehicleDetails } = useAbVehiclesStore();
  const textInputList = questionData.textInputList.map((textInput) => {
    return {
      ...textInput,
      initialTextValue:
        vehicleDetails[textInput.id as keyof typeof vehicleDetails] || '',
      onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
        setErrorMessages([]);
        updateVehicleDetails({
          ...vehicleDetails,
          [textInput.id]: e.target.value,
        });
      },
      errorMessages,
    };
  });

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.HOW_LONG);
    },
  };

  const buttonNext = {
    onClick: () => {
      try {
        const validatedData = abandonedVehicleDetailsSchema.parse({
          registrationNumber: vehicleDetails.registrationNumber || '',
          make: vehicleDetails.make || '',
          model: vehicleDetails.model || '',
          colour: vehicleDetails.colour || '',
        });
        updateVehicleDetails(validatedData);
        navigate(RoutesList.ISSUE_LOCATION);
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error) => ({
            message: error.message,
            path: error.path,
          })),
        );
      }
    },
  };

  return (
    <MultipleTextInputTemplate
      textInputList={textInputList}
      title={questionData.title}
      isLabelTextTitle={true}
      buttonPrevious={buttonPrevious}
      buttonNext={buttonNext}
      errorMessages={errorMessages}
    />
  );
};
